import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

// 進行中的存款訂單：用於浮動按鈕及持久化
//
// 結構：
// {
//   applyId,        訂單唯一識別
//   kind,           'url' | 'cryptoShow'
//   modalName,      'ModalDepositSubmitted' | 'ModalDepositCryptoInProgress'
//   result,         slim subset（modal 重開時所需的最小欄位集）
//   currentPayment, { iconUrl, methodDescription }
//   expiresAt,      絕對 epoch ms
//   uidSite         綁帳號，防換帳號殘留
// }
export const useDepositInProgressStore = defineStore('depositInProgress', () => {
  const activeDepositOrder = ref(null)

  const getActiveDepositOrder = computed(() => activeDepositOrder.value)
  const hasActiveDepositOrder = computed(() => !!activeDepositOrder.value)

  function setActiveDepositOrder(order) {
    activeDepositOrder.value = order
  }

  function clearActiveDepositOrder() {
    activeDepositOrder.value = null
  }

  return {
    activeDepositOrder,
    getActiveDepositOrder,
    hasActiveDepositOrder,
    setActiveDepositOrder,
    clearActiveDepositOrder,
  }
})
